import { clearStorage, setItem, getItem } from "@/utils/storage";
import router from "@/router";
import api from "@/utils/api";
import responseHandler from "@/utils/responseHandler.js";

export const showToast = ({ commit }, payload) => {
    commit("SHOW_TOAST", payload);
};

export const setLoading = ({ commit }, payload) => {
    commit("SET_LOADING", payload);
};

export const setSmallLoading = ({ commit }, payload) => {
    commit("SET_SMALL_LOADING", payload);
};

export const logout = () => {
    clearStorage();
    router.push({ name: "SignIn" });
};

export const verifyPin = async({}, pin) => {
    try {
        const response = await api.verifyPin(pin);
        return response;
    } catch (error) {
        responseHandler.handleError(error);
        return error;
    }
};

export const getCarousel = async({ commit }) => {
    const response = await api.getCarousel();
    const { data } = response.data;
    commit("SET_CAROUSEL", data);
};

export const updateSecondaryModal = async({ state, dispatch }, payload) => {
    await api.updateSecondaryModal(payload);
    const id = getItem("org_details")._id;
    dispatch("organisationModule/getOrganisationProfile", id, { root: true });
};

export const uploadMultipleDoc = async({}, payload) => {
    const response = await api.uploadMultipleDoc(payload);
};

export const updateMultipleDoc = async({}, payload) => {
    try {
        const response = await api.updateMultipleDoc(payload);
        return response;
    } catch (error) {
        responseHandler.handleError(error);
        return error;
    }
};